import { Reveal } from "./Reveal";
import { SectionHead } from "./SectionHead";
import { GALLERY } from "../data/site";

export const Gallery = () => (
  <section data-testid="gallery-section" className="bg-cream-3 border-y border-forest/10">
    <SectionHead
      eyebrow="London, In Detail"
      title="Property, Beautifully Considered"
      text="A glimpse of the homes, streets and details that make London property worth the care we give it."
    />
    <div className="wrap-x pb-24 sm:pb-32 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
      {GALLERY.map((item, i) => (
        <Reveal key={item.caption} delay={i * 0.08} className={`${item.span} ${item.offset || ""}`}>
          <figure
            data-testid={`gallery-item-${i + 1}`}
            className={`group relative overflow-hidden ${item.height}`}
          >
            <img
              src={item.img}
              alt={item.alt}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]"
            />
            <div
              aria-hidden="true"
              className="absolute inset-0 bg-gradient-to-t from-forest-deep/70 via-transparent to-transparent opacity-80 transition-opacity duration-700 group-hover:opacity-100"
            />
            <span
              aria-hidden="true"
              className="absolute inset-4 border border-cream/0 transition-all duration-700 group-hover:border-cream/40 pointer-events-none"
            />
            <figcaption className="absolute bottom-6 left-7 right-7 flex items-end justify-between gap-4">
              <span className="font-serif italic text-cream text-xl sm:text-2xl leading-snug">
                {item.caption}
              </span>
              <span className="font-serif italic text-gold-soft/80 text-lg shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);
